export const FB_PIXEL_ID = "3551592308388834";

export const pageview = () => {
  window.fbq("track", "PageView");
};

export const viewContent = () => {
  window.fbq("track", "ViewContent");
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (name, options = {}) => {
  window.fbq("track", name, options);
};
